import { getRegionApi } from 'src/api/common'

export default {
  namespaced: true,
  state: {
    regionInfo: null,
  },

  mutations: {
    SET_REGION_INFO: (state, info) => {
      state.regionInfo = info || null
    },
  },

  actions: {
    async getRegionInfo ({ state, commit }) {
      try {
        let regionInfo = null
        if (!state.regionInfo) {
          regionInfo = await getRegionApi()
          commit('SET_REGION_INFO', regionInfo)
        }
      } catch (e) {
        return Promise.reject(e)
      }
    },
  },
}
